import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6208ab30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "load_bar_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "load_bar" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "logo_wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "flex logo_buttons_wrapper"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "img_wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "logo_img",
  src: "/assets/img/logo.svg"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "header_title"
}
const _hoisted_12 = {
  key: 0,
  class: "search_wrapper"
}
const _hoisted_13 = {
  class: "current_club_wrapper",
  ref: "clubSelect"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "setting_button_img",
  src: "/assets/img/setting.svg"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "setting_button_img",
  src: "/assets/img/card-search.svg"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "user_wrapper"
}
const _hoisted_19 = { class: "user_name" }
const _hoisted_20 = {
  key: 0,
  class: "user_role"
}
const _hoisted_21 = { class: "ml-3" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "mt-0 mr-2" }
const _hoisted_24 = { class: "switcher" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switcher_switch" }, null, -1))
const _hoisted_26 = { class: "mt-0 ml-2" }
const _hoisted_27 = {
  class: "accept_calls_club_select",
  ref: "acceptCallClubSelect"
}
const _hoisted_28 = {
  key: 0,
  class: "body flex mt-4"
}
const _hoisted_29 = { class: "menu_mobile_search" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr mb-4" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr mt-4 mb-4" }, null, -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "unread_messages_count" }
const _hoisted_35 = { class: "mt-0" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr mb-6" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logout.svg" }, null, -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  class: "body"
}
const _hoisted_42 = { class: "auth_wrapper content_wrapper" }
const _hoisted_43 = { class: "m-0" }
const _hoisted_44 = { class: "auth_text" }
const _hoisted_45 = ["disable"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-auto",
  src: "/assets/img/phone-calling.svg"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "even_messages_wrapper" }
const _hoisted_49 = { class: "my-0" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "my-0" }
const _hoisted_52 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page500 = _resolveComponent("page500")!
  const _component_passCardAlert = _resolveComponent("passCardAlert")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
      [_vShow, _ctx.load]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "setting_button_mobile pointer",
                src: "/assets/img/setting.svg",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickOnOptionsButton && _ctx.clickOnOptionsButton(...args)))
              }),
              _createElementVNode("img", {
                class: _normalizeClass(!_ctx.isShowMenu ? 'hamburger_button mobile_show' : 'hamburger_button mobile_hide'),
                src: "/assets/img/hamburger-button.svg",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowMenu = !_ctx.isShowMenu))
              }, null, 2),
              _createElementVNode("img", {
                class: _normalizeClass(_ctx.isShowMenu ? 'close_button pointer mobile_show' : 'close_button pointer mobile_hide'),
                src: "/assets/img/close.svg",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowMenu = !_ctx.isShowMenu))
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.networkLogo == null)
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.networkLogo != null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "network_logo",
                  src: _ctx.networkLogo
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('main.title')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_v_input, {
              modelValue: _ctx.searchText,
              placeholder: _ctx.$t('main.search'),
              inputType: "text",
              height: 20,
              search: "",
              liveUpdate: true,
              ref: "searchInputHeader",
              "onUpdate:modelValue": _ctx.onSearchInput,
              onPressEnter: _ctx.search
            }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue", "onPressEnter"]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedClub,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedClub) = $event)),
                  _ctx.selectClub
                ],
                label: 'main.current_club',
                class: "w-100",
                items: _ctx.availableClubs,
                labelWithEllipsis: ""
              }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
            ], 512), [
              [_vShow, _ctx.availableClubs.length > 0]
            ]),
            _createElementVNode("button", {
              class: "setting_button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickOnOptionsButton && _ctx.clickOnOptionsButton(...args)))
            }, _hoisted_15),
            (_ctx.hasConnection)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.findCardOwner && _ctx.findCardOwner(...args))),
                  class: "setting_button"
                }, _hoisted_17))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.currentUser?.lastName || '') + " " + _toDisplayString(_ctx.currentUser?.firstName || ''), 1),
              (_ctx.currentUser?.mainRoleName)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t(_ctx.currentUser?.mainRoleName)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                class: "user_photo",
                style: _normalizeStyle({ 'background-image': `url(${_ctx.currentUser?.photoUrl})` })
              }, null, 4)
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.isOptionsOpen ? 'options_wrapper options_mobile_wrapper_show' : 'options_wrapper options_mobile_wrapper_hidden'),
        ref: "options"
      }, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('main.ru')), 1),
          _createElementVNode("label", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isEnLanguageSelect) = $event)),
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.switchLanguage && _ctx.switchLanguage(...args))),
              hidden: ""
            }, null, 544), [
              [_vModelCheckbox, _ctx.isEnLanguageSelect]
            ]),
            _hoisted_25
          ]),
          _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('main.en')), 1)
        ]),
        _createVNode(_component_v_checkbox, {
          modelValue: _ctx.isAcceptCalls,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isAcceptCalls) = $event)),
          label: _ctx.$t('main.accept_calls'),
          onClick: _ctx.clickOnAcceptCalls
        }, null, 8, ["modelValue", "label", "onClick"]),
        _withDirectives(_createElementVNode("div", _hoisted_27, [
          _withDirectives(_createVNode(_component_v_select, {
            modelValue: _ctx.selectedClubForCalls,
            "onUpdate:modelValue": [
              _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedClubForCalls) = $event)),
              _ctx.selectAcceptCallsClub
            ],
            label: 'main.club_for_calls',
            class: "w-100 mt-3",
            items: _ctx.availableClubsForCalls,
            onClick: _ctx.resizeOptionWindow,
            onOptionsClosed: _ctx.resizeOptionWindow
          }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue", "onClick", "onOptionsClosed"]), [
            [_vShow, _ctx.availableClubs.length > 0]
          ])
        ], 512), [
          [_vShow, _ctx.isAcceptCalls]
        ])
      ], 2)), [
        [_vShow, _ctx.isOptionsOpen],
        [_directive_click_outside, _ctx.onClickOutsideOptions]
      ])
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ]),
    (_ctx.isAuth && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(_ctx.isShowMenu ? 'menu_wrapper menu_wrapper_show' : 'menu_wrapper menu_wrapper_hide')
          }, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_v_input, {
                modelValue: _ctx.searchText,
                placeholder: _ctx.$t('main.search'),
                inputType: "text",
                search: "",
                liveUpdate: true,
                ref: "searchInputMobile",
                "onUpdate:modelValue": _ctx.onSearchInput,
                onPressEnter: _ctx.search
              }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue", "onPressEnter"]),
              _withDirectives(_createVNode(_component_v_select, {
                modelValue: _ctx.selectedClub,
                "onUpdate:modelValue": [
                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedClub) = $event)),
                  _ctx.selectClub
                ],
                label: 'main.current_club',
                class: "w-100 mt-3",
                items: _ctx.availableClubs
              }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]), [
                [_vShow, _ctx.availableClubs.length > 0]
              ]),
              _hoisted_31
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.text,
                class: "menu_item_wrapper"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(item.url == _ctx.activeMenuItem ? 'menu_item menu_active' : 'menu_item'),
                  onClick: ($event: any) => (_ctx.clickOnMenuItem(item))
                }, [
                  _createElementVNode("img", {
                    src: '/assets/img/' + item.icon
                  }, null, 8, _hoisted_33),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(item.text)) + " ", 1),
                  _withDirectives(_createElementVNode("div", _hoisted_34, [
                    _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.unreadChatMessageCount > 9 ? '9+' :_ctx.unreadChatMessageCount), 1)
                  ], 512), [
                    [_vShow, item.url == '/chats' && _ctx.unreadChatMessageCount != 0]
                  ]),
                  (item.hasSubItems)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "menu_item_arrow",
                        src: item.isOpen ? '/assets/img/arrow-up.svg' : '/assets/img/arrow-down.svg'
                      }, null, 8, _hoisted_36))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_32),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subItems, (subItem) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: subItem.text,
                    onClick: ($event: any) => (_ctx.clickOnMenuItem(subItem))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(subItem.url == `${_ctx.activeMenuItem}${_ctx.activeSubmenuItem}` ? 'menu_item pl-8 menu_active' : 'menu_item pl-8')
                    }, _toDisplayString(_ctx.$t(subItem.text)), 3)
                  ], 8, _hoisted_37)), [
                    [_vShow, item.isOpen]
                  ])
                }), 128))
              ]))
            }), 128)),
            _createElementVNode("div", null, [
              _hoisted_38,
              _createElementVNode("div", {
                class: "menu_item mb-0",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
              }, [
                _hoisted_39,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.sign_out')), 1)
              ])
            ])
          ], 2)), [
            [_directive_click_outside, _ctx.clickOutsideMenu]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.isShowMenu ? 'body_content body_content_with_menu' : 'body_content body_content_without_menu')
          }, [
            (!_ctx.isUpdating)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_router_view)
                ], 512)), [
                  [_vShow, !_ctx.isShowInternalServerError]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_page500, null, null, 512), [
              [_vShow, _ctx.isShowInternalServerError]
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAuth && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h1", _hoisted_43, _toDisplayString(_ctx.$t('main.sign_in')), 1),
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('main.sign_in_text')), 1),
            _createVNode(_component_v_input, {
              class: "mt-8",
              modelValue: _ctx.login,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.login) = $event)),
              label: _ctx.$t('main.login'),
              placeholder: _ctx.$t('main.login_placeholder'),
              inputType: "text",
              errorText: _ctx.loginErrorText,
              height: "28",
              onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loginErrorText = '')),
              onPressEnter: _ctx.signIn,
              clearable: ""
            }, null, 8, ["modelValue", "label", "placeholder", "errorText", "onPressEnter"]),
            _createVNode(_component_v_input, {
              class: "mt-7",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.password) = $event)),
              label: _ctx.$t('main.password'),
              placeholder: _ctx.$t('main.password_placeholder'),
              errorText: _ctx.passwordErrorText,
              inputType: _ctx.passwordInputType,
              onChangeType: _ctx.changeType,
              height: "28",
              onPressEnter: _ctx.signIn,
              password: "",
              onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.passwordErrorText = ''))
            }, null, 8, ["modelValue", "label", "placeholder", "errorText", "inputType", "onChangeType", "onPressEnter"]),
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.isLoginButtonDisable ? 'auth_button disable_button' : 'auth_button'),
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
              disable: _ctx.isLoginButtonDisable
            }, _toDisplayString(_ctx.$t('main.sign_in_button')), 11, _hoisted_45)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "calling_wrapper",
      id: "callingButton",
      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clickOnCallingButton && _ctx.clickOnCallingButton(...args)))
    }, _hoisted_47, 512), [
      [_vShow, _ctx.isAuth && !_ctx.isLeadOpen && _ctx.leadCalling?.isCallingNow]
    ]),
    _createElementVNode("div", _hoisted_48, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "error",
          key: error
        }, [
          _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t(error)), 1),
          _createElementVNode("img", {
            class: "error_close",
            src: "/assets/img/close-red.svg",
            onClick: ($event: any) => (_ctx.closeError(error))
          }, null, 8, _hoisted_50)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.successMessages, (successMessage) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "success",
          key: successMessage
        }, [
          _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t(successMessage)), 1),
          _createElementVNode("img", {
            class: "success_close",
            src: "/assets/img/close-green.svg",
            onClick: ($event: any) => (_ctx.closeSuccessMessages(successMessage))
          }, null, 8, _hoisted_52)
        ]))
      }), 128))
    ]),
    (_ctx.isShowFindCard)
      ? (_openBlock(), _createBlock(_component_passCardAlert, {
          key: 2,
          title: 'pass_card.pass_card_alert.find_card',
          onClose: _ctx.closeFindCard
        }, null, 8, ["title", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}